import WordHit from "./components/WordHit";
function App() {
  return <WordHit />;
}
export default App;